import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-dropdown',
  templateUrl: './app-dropdown.component.html',
  styleUrls: ['./app-dropdown.component.scss']
})
export class AppDropdownComponent {

  @Input() data: AppDropdownModel[] = [];
  @Input() title: string = "Selecione";
  @Input() placeholder: string = "";
  @Input() customMessageError: string = "";
  @Input() control: FormControl;
  @Input() showErrorLabel: boolean = true;
  @Output() onClick = new EventEmitter<AppDropdownModel>();

  onChange(event): void {
    this.onClick.emit(event.value);
  }

  get isInvalid() {
    return (this.control && this.control.errors && (this.control.dirty || this.control.touched));
  }

}

export interface AppDropdownModel {
  label: string;
  value: string;
}